export default __webpack_public_path__ + "static/media/dragon1.fcd94fb2.jpg";